var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 180,
    viewBox: "0 0 430 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453 48.1875C453 58.1978 444.955 66.3125 435.031 66.3125C425.107 66.3125 417.062 58.1978 417.062 48.1875",
    stroke: "#FFB017",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.753 118.643C356.083 143.585 370.513 169.129 394.983 175.699C419.453 182.266 444.701 167.372 451.372 142.43C458.042 117.488 443.612 91.9447 419.142 85.375",
    stroke: "#44AB96",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409.871 7.875C409.871 18.4028 418.269 26.9375 428.625 26.9375C438.981 26.9375 447.375 18.4028 447.375 7.875C447.375 -2.65278 438.981 -11.1875 428.625 -11.1875H365.812",
    stroke: "#44AB96",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.504 186.062C204.504 175.535 196.106 167 185.75 167C175.394 167 167 175.535 167 186.062C167 196.59 175.394 205.125 185.75 205.125H248.562",
    stroke: "#44AB96",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.912 159.125C238.912 149.115 246.963 141 256.894 141C266.825 141 274.875 149.115 274.875 159.125C274.875 169.135 266.825 177.25 256.894 177.25H228.312",
    stroke: "#FFB017",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M405.969 113.138C415.893 113.138 423.938 121.125 423.938 130.975C423.938 140.825 415.893 148.812 405.969 148.812C396.045 148.812 388 140.825 388 130.975V14.75",
    stroke: "#E53855",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.438 124.75C271.438 106.456 286.077 91.625 304.136 91.625H361.75",
    stroke: "#44AB96",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M365.812 15.375V32.1735C365.812 49.1293 352.062 62.875 335.098 62.875H311.125",
    stroke: "#4484AB",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245.031 99.125C245.031 100.106 245.031 112.449 245.031 118.5",
    stroke: "#FFB017",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M344.813 -80.5625C344.813 -84.1524 341.902 -87.0625 338.313 -87.0625C334.723 -87.0625 331.813 -84.1524 331.813 -80.5625H344.813ZM302.556 29.2204C298.966 29.2204 296.056 32.1305 296.056 35.7204C296.056 39.3102 298.966 42.2204 302.556 42.2204V29.2204ZM251.125 70.7501C247.535 70.7501 244.625 73.6602 244.625 77.2501C244.625 80.84 247.535 83.7501 251.125 83.7501V70.7501ZM297.3 45.9808C297.3 42.3909 294.39 39.4808 290.8 39.4808C287.21 39.4808 284.3 42.3909 284.3 45.9808H297.3ZM331.813 -80.5625V-36.0842H344.813V-80.5625H331.813ZM331.813 -36.0842C331.813 -32.7258 329.056 -29.9168 325.542 -29.9168V-16.9168C336.135 -16.9168 344.813 -25.4457 344.813 -36.0842H331.813ZM325.542 -29.9168C314.947 -29.9168 306.272 -21.3804 306.272 -10.7446H319.272C319.272 -14.1065 322.032 -16.9168 325.542 -16.9168V-29.9168ZM306.272 -10.7446V-8.11624H319.272V-10.7446H306.272ZM306.272 -8.11624C306.272 2.51905 314.947 11.056 325.542 11.056V-1.94399C322.032 -1.94399 319.272 -4.75461 319.272 -8.11624H306.272ZM325.542 11.056C329.053 11.056 331.813 13.8664 331.813 17.2283H344.813C344.813 6.59248 336.138 -1.94399 325.542 -1.94399V11.056ZM331.813 17.2283V20.1382H344.813V17.2283H331.813ZM331.813 20.1382C331.813 25.1071 327.74 29.2204 322.61 29.2204V42.2204C334.825 42.2204 344.813 32.381 344.813 20.1382H331.813ZM322.61 29.2204H314.475V42.2204H322.61V29.2204ZM314.475 29.2204H302.556V42.2204H314.475V29.2204ZM251.125 83.7501H259.493V70.7501H251.125V83.7501ZM259.493 83.7501C280.366 83.7501 297.3 66.8478 297.3 45.9808H284.3C284.3 59.6531 273.201 70.7501 259.493 70.7501V83.7501Z",
    fill: "#E53855"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.312 137.865C293.312 125.273 303.526 115.062 316.125 115.062V115.062C328.723 115.062 338.938 125.273 338.938 137.865V154.448C338.938 167.04 328.723 177.25 316.125 177.25V177.25C303.526 177.25 293.312 167.04 293.312 154.448V137.865Z",
    stroke: "#4484AB",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashone);
export default __webpack_public_path__ + "static/media/dashone.6e4c2a26c7add293bedf3b1eb85fa144.svg";
export { ForwardRef as ReactComponent };